import { render, staticRenderFns } from "./InternalMovingTabs.vue?vue&type=template&id=262a478c&scoped=true"
import script from "./InternalMovingTabs.vue?vue&type=script&lang=js"
export * from "./InternalMovingTabs.vue?vue&type=script&lang=js"
import style0 from "./InternalMovingTabs.vue?vue&type=style&index=0&id=262a478c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262a478c",
  null
  
)

export default component.exports